import { render } from "./mode.vue?vue&type=template&id=0e9c9a2d&ts=true"
import script from "./mode.vue?vue&type=script&lang=ts"
export * from "./mode.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/mode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e9c9a2d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e9c9a2d', __exports__)) {
    api.reload('0e9c9a2d', __exports__)
  }
  
  module.hot.accept("./mode.vue?vue&type=template&id=0e9c9a2d&ts=true", () => {
    api.rerender('0e9c9a2d', render)
  })

}


export default __exports__